import { SideMenuContent } from '@/components/NewHeader/SideMenu/SideMenuContent';
import { useSideMenu } from '@/components/NewHeader/SideMenu/useSideMenu';
import { TopHeader } from '@/components/NewHeader/TopHeader';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
} from '@/components/Sheet';

export function SideMenu() {
  const { isOpen, toggle } = useSideMenu();

  return (
    <Sheet open={isOpen} onOpenChange={toggle}>
      <SheetTrigger asChild></SheetTrigger>
      <SheetContent>
        <SheetTitle className="hidden" />
        <SheetDescription className="hidden" />
        <TopHeader />
        <SideMenuContent />
      </SheetContent>
    </Sheet>
  );
}

// export function SideMenu({ children }: { children: JSX.Element }) {
//   const { isOpen, toggle } = useSideMenu();

//   return (
//     <Sheet open={isOpen} onOpenChange={toggle}>
//       <SheetTrigger asChild>
//         <button>{children}</button>
//       </SheetTrigger>
//       <SheetContent>
//         <SheetTitle className="bg-black/5 flex justify-between">
//           <div className="pl-4 flex gap-2">
//             <HeaderDropdowns />
//           </div>

//           <div className="flex gap-2">
//             <ShortListModalContent isOnSideMenu />
//             <SearchButton />
//             <SheetClose className="relative top-0 right-0 size-10 bg-primary flex justify-center items-center">
//               <XIcon className="size-6" />
//               <span className="sr-only">Close</span>
//             </SheetClose>
//           </div>
//         </SheetTitle>

//         <div className="p-4">
//           <Image
//             priority={true}
//             src={logoBlue}
//             className="w-56 h-10"
//             alt="Logo Villatravellers"
//           />
//         </div>

//         <SideMenuContent />
//       </SheetContent>
//     </Sheet>
//   );
// }
